import React from 'react';
import { TopBar } from '../NavigationBar/TopBar';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ArrowRight } from 'lucide-react';
import type { SortOption } from './GraphListLayout';

interface Props {
    className?: string;
    onCreateGraphClicked: () => void;
    sortBy: SortOption;
    onSortChange: (value: SortOption) => void;
}

export const GraphListTopBar: React.FC<Props> = ({ onCreateGraphClicked, sortBy, onSortChange, className = '' }) => {
    return (
        <TopBar
            className={className}
            renderRightSection={() => (
                <div className="flex items-center gap-2">
                    <Select value={sortBy} onValueChange={value => onSortChange(value as SortOption)}>
                        <SelectTrigger className="w-[160px] h-8 text-sm">
                            <SelectValue placeholder="Sort by" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="updatedAt">Last Updated</SelectItem>
                            <SelectItem value="createdAt">Recently Created</SelectItem>
                        </SelectContent>
                    </Select>
                    <Button onClick={onCreateGraphClicked} className="gap-2">
                        Create Workflow
                        <ArrowRight className="h-4 w-4" />
                    </Button>
                </div>
            )}
        />
    );
};
